import React, { Component } from 'react'
import Navbar from "../../Components/Navbar"
import Footer from "../../Components/Footer"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import imgError from "../../images/404.png"
import './404.css'

class Page404 extends Component {
    render() {
        return (
            <>
                <Navbar />
                <section className="insideSec">
                    <Container className="pt-5">
                        <Row className="pt-5">
                            <Col md={12}>
                                <h1 className="tx-pink font-weight-bold errorTitle display-4 text-center">ERRO #404</h1>
                                <h2 className="tx-pink text-center font-weight-bold">ESSA PÁGINA NÃO EXISTE</h2>
                                <img src={imgError} className="img-fluid img-error" />
                                <center><a href="/" className="back-button">Voltar</a></center>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <Footer background />
            </>
            
        )
    }
}


export default Page404